// Business facts used by the React app, the build-time prerender and the structured data.
// Plain CommonJS on purpose: scripts/prerender.js runs this on Node 12 without a bundler.
// Edit facts here, never in components.

const BASE_URL = "https://www.americanlegacytours.com";
const CLOUDINARY = "https://res.cloudinary.com/american-legacy-tours/image/upload";

const SOCIAL = {
  facebook: "https://www.facebook.com/AmericanLegacyTours",
  twitter: "https://twitter.com/AmLegacyTours",
  instagram: "https://www.instagram.com/americanlegacycincy",
  tripadvisor:
    "https://www.tripadvisor.com/Attraction_Review-g60993-d4432364-Reviews-American_Legacy_Tours-Cincinnati_Ohio.html",
  googleReviews:
    "https://www.google.com/search?q=American+Legacy+Tours#lrd=0x8841b3fd868b6ea1:0xfae885fabe92c950,1,,,",
};

module.exports = {
  BASE_URL: BASE_URL,
  SITE_NAME: "American Legacy Tours",
  TAGLINE: "Historically Entertaining",
  TITLE_SUFFIX: " | American Legacy Tours",
  CLOUDINARY: CLOUDINARY,
  DEFAULT_OG_IMAGE: CLOUDINARY + "/c_fill,h_630,w_1200/f_auto,q_auto/img/home/slider/slider-01",
  LOGO: CLOUDINARY + "/f_auto,q_auto/img/logo-color-big",

  NAP: {
    streetAddress: "1332 Vine St",
    addressLocality: "Cincinnati",
    addressRegion: "OH",
    postalCode: "45202",
    addressCountry: "US",
    telephone: "+1-859-951-8560",
    telephoneHref: "tel:+18599518560",
    telephoneDisplay: "(859) 951-8560",
    email: "questions@americanlegacytours.com",
  },
  GEO: { latitude: 39.1106104, longitude: -84.51524 },
  MAPS_URL: "https://www.google.com/maps/place/American+Legacy+Tours/@39.1106104,-84.51524,15z",
  SERVICE_AREA: ["Cincinnati, OH", "Newport, KY", "Covington, KY"],

  SOCIAL: SOCIAL,
  SAME_AS: [SOCIAL.facebook, SOCIAL.twitter, SOCIAL.instagram, SOCIAL.tripadvisor],

  FOUNDING_DATE: "2009",
  PRICE_RANGE: "$20-$49",

  // Tour categories shown in the nav and used to group tours for crawlers.
  CATEGORIES: [
    { key: "underground", label: "Underground Tours" },
    { key: "historic", label: "Historic Tours" },
    { key: "foodanddrink", label: "Food & Drink Tours" },
    { key: "haunted", label: "Haunted Tours" },
  ],
  GROUP_LABELS: {
    underground: "Underground",
    historic: "Historic",
    history: "Historic",
    haunted: "Haunted",
    foodanddrink: "Food & Drink",
    holiday: "Holiday",
  },

  SUMMARY:
    "American Legacy Tours is Cincinnati's award-winning walking tour company. Since 2009 we have led historic, haunted, underground, and food & drink tours through Cincinnati, Newport, and Covington, including the Queen City Underground and the Newport Gangster Tour. Tours are led by entertaining local guides, run rain or shine, and can be booked online or arranged privately for groups.",

  OPENING_HOURS: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      opens: "09:00",
      closes: "16:00",
    },
    { "@type": "OpeningHoursSpecification", dayOfWeek: "Sunday", opens: "08:00", closes: "18:00" },
  ],

  // Marketing claims that appear in several places. Update here when the numbers change.
  REVIEW_STATS: {
    rating: "4.9",
    countLabel: "3,500+",
    awardYears: "2022, 2023 & 2024",
    awardName: "TripAdvisor Travelers' Choice Award",
  },

  // EmailJS public identifiers (safe to ship; restrict allowed domains in the EmailJS dashboard).
  EMAILJS: {
    serviceId: "service_thlhokp",
    publicKey: "pspiVumi2F-ZjP1oN",
    contactTemplate: "template_a5nz49a",
    privateTourTemplate: "template_ydl9hbe",
  },
  // Google Maps Embed key (client-side by design; keep it referrer-restricted in Google Cloud).
  GOOGLE_MAPS_EMBED_KEY: "AIzaSyAF0pVwRqx_wSImGwi80X7chUgzKdq1Q_E",
  // GA4 is wired in public/index.html; kept here so docs and scripts can reference it.
  GA4_MEASUREMENT_ID: "G-JGEZ070D9V",
};
